import * as _ from 'lodash';
import { Registration } from '../interfaces';
import { Element } from './element';
import { FormGroup, FormControl, FormArray, AbstractControl } from '@angular/forms';

export class MultiSelectElement extends Element implements Registration.Form.IMultiSelectElement {
    public values: [{ name: string; value: string; inputKey: string}];
    public controls: FormControl[];

    constructor(dto: Registration.Form.IElement) {
        super(dto);
        this.addOptionValues(dto.options);
        this.controls = [];
    }

    private addOptionValues(options: Registration.Form.IOption[]) {
        this.values = <null>[];
        _.each(options, (option) => {
            const index = options.indexOf(option);
            this.values.push({ name: option.name, value: undefined, inputKey: this.inputKey + index});
        });
    }
}
